<template>
  <div>

    <v-expansion-panels
      v-model="expandState"
      multiple
      class="mb-1"
    >
      <v-expansion-panel >

        <v-expansion-panel-header color="secondary" dark dense class="ids-expansion-panel-header">
          <v-icon class="ids-expansion-header-left-icon pr-2">
            mdi-image-filter-tilt-shift
          </v-icon>
          {{ corpusCategoryName }}
          <v-btn
            icon
            :title="toggleAllTooltip"
            style="margin-right: 20px;"
            @click="toggleAllCorpora"
            @click.stop
          >
            <v-icon class="">{{ toggleAllIcon }}</v-icon>
          </v-btn>
        </v-expansion-panel-header>

        <v-expansion-panel-content>

          <!-- checkboxes -->
          <v-container
            fluid
          >
            <v-row no-gutters>
              <v-col :cols="12" v-for="(cbItem, index) in corpusItems" :key="cbItem.label">
                <v-checkbox
                  v-model="dataSelection[index]"
                  :value="cbItem.v_corpus_id"
                  :label="corpusLabel(cbItem.v_corpus_id)"
                  hide-details
                  dense
                  class="ids-corpus-checkbox"
                >
                <template v-slot:label>
                  <div>
                    {{corpusLabel(cbItem.v_corpus_id)}}
                    <a
                      target="_blank"
                      :href="corpusLink(cbItem.v_corpus_id)"
                      @click.stop
                      style="text-decoration: none;"
                    >
                      <v-icon>mdi-information-outline</v-icon>
                    </a>
                  </div>
                </template>
                </v-checkbox>

              </v-col>
            </v-row>

          </v-container>
          <!-- END checkboxes -->

        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

  </div>
</template>

<script>
import { WguEventBus } from '../../../../src/WguEventBus.js';
import IdsCorpusLookup from '../../IdsCorpusLookup.js';

export default {
  name: 'ids-corpus-category',
  props: {
    corpusCategoryName: { type: String, required: true },
    corpusItems: { type: Array, required: true },
    selection: { type: Array, required: false, default: () => [] }
  },
  data () {
    return {
      dataSelection: this.selection,
      expandState: [0], // expand the content by default
      toggleAllIcon: 'mdi-checkbox-multiple-marked-outline',
      toggleAllTooltip: 'Alle Einträge aus dieser Kategorie selektieren'
    }
  },

  created () {
    WguEventBus.$on('ids-locationtype-change', () => {
      // reset to initial corpus selection
      this.dataSelection = this.dataSelection;
      // this.dataSelection = [];
      // const initCorpusIds = IdsCorpusLookup.initialCorpusIds;
      // const initSelArr = IdsCorpusLookup.getSelectionObjectByArr(initCorpusIds);
      // this.dataSelection = initSelArr[this.corpusCategoryName];
    });
  },
  watch: {
    dataSelection (newSelected) {
      // inform parent component
      this.$emit('ids-corpus-selection-change', this.corpusCategoryName, newSelected);

      // change icon and tooltip for toggling all selections
      const allSelected = this.allSelected();
      if (allSelected) {
        this.toggleAllIcon = 'mdi-checkbox-multiple-blank-outline';
        this.toggleAllTooltip = 'Alle Einträge aus dieser Kategorie deselektieren';
      } else {
        this.toggleAllIcon = 'mdi-checkbox-multiple-marked-outline';
        this.toggleAllTooltip = 'Alle Einträge aus dieser Kategorie selektieren';
      }
    }
  },
  methods: {
    corpusLabel (corpusId) {
      return IdsCorpusLookup.getCorpusLabel(corpusId);
    },
    corpusLink (corpusId) {
      return IdsCorpusLookup.getCorpusLink(corpusId);
    },
    /**
     * Selects all corpora if not all selected or deselects all corpora if all
     * corpora are currently selected.
     */
    toggleAllCorpora () {
      const allSelected = this.allSelected();
      if (allSelected) {
        this.dataSelection = [];
      } else {
        this.dataSelection = IdsCorpusLookup.getAllSelected(this.corpusCategoryName);
      }
    },
    /**
     * Checks if all corpora in this category are selected or not.
     */
    allSelected () {
      // filter out empty or null values
      const selectionArr = this.dataSelection.filter(
        x => { return (typeof x === 'string') }
      );
      return selectionArr.length === this.corpusItems.length;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .v-expansion-panel-header > .ids-expansion-header-left-icon {
    /* ensure icon in expansion-header is left */
    flex: 0;
  }

  @media only screen and (max-width: 600px) {
    .ids-corpus-checkbox {
      margin: 0
    }

    .ids-expansion-panel-header {
      font-size: small;
    }
  }
</style>



// WEBPACK FOOTER //
// app/ids/components/filter/IdsCorpusCategory.vue